import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

function TypingMessage({ content, onTypingComplete }) {
  const [displayedText, setDisplayedText] = useState('');
  const [typedMarkdown, setTypedMarkdown] = useState(''); // Armazena o markdown progressivo
  const typingSpeed = 200; // Velocidade de digitação em milissegundos

  useEffect(() => {
    let index = 1;
    const interval = setInterval(() => {
      setDisplayedText(content.slice(0, index + 1)); // Atualiza o texto
      setTypedMarkdown(content.slice(0, index + 1)); // Atualiza o markdown
      index++;
      if (index > content.length) {
        clearInterval(interval);
        if (onTypingComplete) {
          onTypingComplete(content);
        }
      }
    }, typingSpeed);

    return () => clearInterval(interval);
  }, [content, onTypingComplete]);

  return (
    <div className="message assistant">
      <ReactMarkdown>{typedMarkdown}</ReactMarkdown>
    </div>
  );
}

export default TypingMessage;
